import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const FeatureContext = createContext({ flags: {}, enabled: () => false, refresh: () => {} });

export function FeatureProvider({ children }) {
  const { user } = useAuth();
  const [flags, setFlags] = useState({});

  const refresh = useCallback(() => {
    api.get("/features/me").then(({ data }) => setFlags(data || {})).catch(() => setFlags({}));
  }, []);

  useEffect(() => {
    if (user && user !== false) refresh();
    else setFlags({});
  }, [user, refresh]);

  const enabled = useCallback((key) => !!flags[key], [flags]);

  return (
    <FeatureContext.Provider value={{ flags, enabled, refresh }}>
      {children}
    </FeatureContext.Provider>
  );
}

export const useFeatures = () => useContext(FeatureContext);
